import { useField } from 'formik';

import { DatePicker, DatePickerProps } from '../../../cdl/DatePicker/DatePicker';
import { formatLocalDateToUtcTimestamp } from '../../../order/create-enquiry/util/formatLocalDateToUtcTimestamp';
import { MILLISECONDS_IN_MINUTE } from '../../time.constants';

interface FormikDatePickerProps extends Pick<DatePickerProps, 'label' | 'markAsRequired' | 'caption'> {
    name: string;
}

export const FormikTimestampDatePicker = ({ name, ...rest }: FormikDatePickerProps) => {
    const [field, meta, helpers] = useField(name);

    const onDateChange = (date: Date | undefined) => {
        helpers.setTouched(true);
        if (date) {
            helpers.setValue(formatLocalDateToUtcTimestamp(date));
        } else {
            helpers.setValue(null);
        }
    };

    const formatUtcTimestampToLocalDate = (timestamp: number) => {
        const date = new Date(timestamp);
        const timezoneOffset = date.getTimezoneOffset() * MILLISECONDS_IN_MINUTE * -1;

        return new Date(date.getTime() - timezoneOffset);
    };

    return (
        <DatePicker
            {...rest}
            date={field.value ? formatUtcTimestampToLocalDate(field.value) : undefined}
            onDateChange={onDateChange}
            negative={meta.touched && !!meta.error}
            caption={meta.touched && meta.error ? meta.error : rest.caption}
            onBlur={() => helpers.setTouched(true)}
        />
    );
};
